export default "__VITE_ASSET__CJdDcVlF__"